import {
    AddCategory,
    AddFlowableModel,
    DeleteCategory,
    DeleteFlowableModel,
    QueryCategoryTree,
    QueryFlowableModel,
    QueryFlowableModelList,
    SaveModelFlowable,
    UpdateCategory,
    UpdateFlowableModel
} from '../../request/flowable';

export default {
    namespace: true,
    state: {
        categoryTree: [],
        categoryComTree: [],
        flowableModelList: []
    },

    mutations: {
        SET_CATEGORY_TREE(state, categoryTree) {
            state.categoryTree = categoryTree;
        },
        SET_COMMON_CATEGORY_TREE(state, categoryComTree) {
            state.categoryComTree = categoryComTree;
        },
        SET_FLOWABLE_MODEL_LIST(state, flowableModelList) {
            state.flowableModelList = flowableModelList;
        }
    },
    actions: {
        QUERY_CATEGORY_TREE: async ({ commit }, payload) => {
            let res = await QueryCategoryTree(payload);
            if (res?.code == 200) {
                commit('SET_CATEGORY_TREE', [{ categoryName: '根目录', id: -1 }, ...res.data]);
                commit('SET_COMMON_CATEGORY_TREE', res.data);
            }
            return res;
        },

        ADD_CATEGORY: async ({ commit }, payload) => {
            let res = await AddCategory(payload);
            return res;
        },

        UPDATE_CATEGORY: async ({ commit }, payload) => {
            let res = await UpdateCategory(payload);
            return res;
        },

        DELETE_CATEGORY: async ({ commit }, payload) => {
            let res = await DeleteCategory(payload);
            return res;
        },

        QUERY_FLOWABLE_MODEL: async ({ commit }, payload) => {
            let res = await QueryFlowableModel(payload);
            return res;
        },

        ADD_FLOWABLE_MODEL: async ({ commit }, payload) => {
            let res = await AddFlowableModel(payload);
            return res;
        },

        UPDATE_FLOWABLE_MODEL: async ({ commit }, payload) => {
            let res = await UpdateFlowableModel(payload);
            return res;
        },

        DELETE_FLOWABLE_MODEL: async ({ commit }, payload) => {
            let res = await DeleteFlowableModel(payload);
            return res;
        },

        QUERY_FLOWABLE_MODEL_LIST: async ({ commit }, payload) => {
            let res = await QueryFlowableModelList(payload);
            return res;
        },

        SAVE_MODEL_FLOWABLE: async ({ commit }, payload) => {
            let res = await SaveModelFlowable(payload);
            return res;
        }
    }
};
